import { VirtualActionTypes, SignalRTypes } from '../actions';

const initState = {
    error: null,
    loading: false,
    data: [],
    loadingKironEvents:false
};

const virtual = (state = initState, action) => {

    switch (action.type) {

        case VirtualActionTypes.Load_Request:
            return { ...state }
        case SignalRTypes.KironSportEvents_Request:
            return {
                ...state,
                barItems: {},
                loadingKironEvents: true
            }
        case SignalRTypes.KironEvent_Request:
            return {
                ...state,
                loadingKironEvents: true,
            }
        case SignalRTypes.KironEvent_Response:
            return {
                ...state,
                loadingKironEvents: false,
            }
        default:
            return state;

    }
}

export default virtual;